import { render, staticRenderFns } from "./ApplicationDocument.vue?vue&type=template&id=2122ccb0&scoped=true&"
import script from "./ApplicationDocument.vue?vue&type=script&lang=js&"
export * from "./ApplicationDocument.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationDocument.vue?vue&type=style&index=0&id=2122ccb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2122ccb0",
  null
  
)

export default component.exports